import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';
import $ from 'jquery';
import { Button } from 'antd';
import AceEditor from 'react-ace';
import { DraggableModal, DraggableModalContext, DraggableModalProvider } from 'ant-design-draggable-modal';
import 'antd/dist/antd.css';
import 'ant-design-draggable-modal/dist/index.css';
import ModalsService from 'services/ModalsService';
import LoadingSpinner from 'components/core/LoadingSpinner';

const dodUrl = process.env.REACT_APP_DOD_URL; // this set via webpack build during transpile

export default class DataConsolidatorImportedDodDialog extends React.Component {
    static propTypes = {
        processId: PropTypes.string,
        dod: PropTypes.string,
        runDate: PropTypes.string,
        version: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const indent = css`
            margin-left: 20px;
        `;
        const url = `${dodUrl}?dodId=${this.props.dod}&versionId=${this.props.version}`;
        return (
            <div>
                <p style={{ fontWeight: 'bold' }}>
                    DOD {this.props.dod} v {this.props.version} has been created!
                </p>

                <p className={indent}>
                    Please visit the DOD application at:
                </p>

                <p className={indent}>
                    <a className={indent} href={url} target="_blank" rel="noopener noreferrer">
                        {url}
                    </a>
                </p>

                <p className={indent}>
                    to make any corrections and validate DOD rules.
                </p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/DataConsolidatorImportedDodDialog.js